if (!window.customElements.get('product-bundle-details')) {
  class ProductBundleDetails extends HTMLElement {
    constructor() {
      super();
      this.productHandle = this.getAttribute('data-bundle-product-handle');
      this.bundleProductDescription = this.querySelector('[data-bundle-product-description]');
      this.bundleProductAccordions = this.querySelector('[data-bundle-product-accordions]');
    }

    connectedCallback() {
      this.getSectionData();
    }

    getSectionData() {
      fetch(`/products/${this.productHandle}`, {
        method: 'GET',
        headers: { 'Accept': 'text/html' }
      })
      .then((response) => {
        if (!response.ok) throw new Error(`HTTP ${response.status}`);
          return response.text();
        })
      .then((html) => {
        this.buildSections(html)
      })
      .catch((err) => {
        console.error('ProductBundleDetails fetch failed:', err)
      });
    }

    buildSections(response) {
      if (this.bundleProductDescription) {
        this.bundleProductDescription.innerHTML = this.getSectionInnerHTML(response, '[data-product-description]');
      }

      if (this.bundleProductAccordions) {
        this.bundleProductAccordions.innerHTML = this.getSectionInnerHTML(response, '[data-product-accordions]');
      }
    }

    getSectionInnerHTML(html, selector) {
      if (!html) return '';

      const target = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);

      if (target)
        return target.innerHTML;
      else
        return '';
    }
  }

  window.customElements.define('product-bundle-details', ProductBundleDetails);
}